import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { showDetails } from "@client.components/Charts";
import useModal from "@client.hooks/useModal";
import { getTopMeetingParticipantsDetailedInformation } from "@client.components/Charts";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { makeFilter } from "@client.components/TopChartFilters/reducer";
import { useNavigate } from "react-router-dom";

const TimeMeetingParticipantNameCell = ({ rowData }) => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const filter = useSelector(makeFilter);

  const getDetailedInformation = useCallback(
    (payload) => {
      return getTopMeetingParticipantsDetailedInformation(payload, t, filter);
    },
    [t, filter]
  );

  return (
    <span
      className="name-cell"
      onClick={() =>
        showDetails(
          rowData,
          showModal,
          getDetailedInformation,
          t,
          filter,
          navigate
        )
      }
    >
      {rowData.name}
    </span>
  );
};

TimeMeetingParticipantNameCell.propTypes = {
  rowData: PropTypes.any.isRequired,
};

export default TimeMeetingParticipantNameCell;
